import { useUiPresentationStore } from '@store'
import type { Item, LinkedItem } from '@types'
import type CameraControls from 'camera-controls'
import { PerspectiveCamera } from 'three'

import {
  applyDrawTopDownCameraView,
  buildDrawTopDownCameraView,
  markDrawFitOrbitSyncPending,
} from './drawTopDownCamera'
import { captureCameraViewFromControls, isValidCameraView, type CameraView } from './cameraView'
import { computeItemsFootprintForDrawFit } from './fitCameraToItems'

// Corresponde a Atemporal (adaptado de applyDrawCameraFit.ts, commit 47ee2081):
// en chrome táctil el canvas es más bajo, se aplica pan-up para que la pieza no
// quede arriba del frame y un ligero alejamiento extra en viewports cortos.
/** En chrome táctil el canvas es más bajo: pan-up para que la pieza no quede arriba del frame. */
const TOUCH_DRAW_FIT_PAN_UP = 420
/** Ligero alejamiento en viewports cortos. */
const TOUCH_DRAW_FIT_EXTRA_DEPTH = 350

/**
 * Encuadra la cámara en vista cenital al dibujar.
 * Solo mueve/orienta la cámara; la matriz del módulo no se modifica.
 */
export function applyDrawCameraFit(
  controls: CameraControls,
  camera: PerspectiveCamera,
  items: Map<string, Item | LinkedItem>,
): CameraView | null {
  const footprint = computeItemsFootprintForDrawFit(items)
  if (!footprint) return null

  const view = buildDrawTopDownCameraView(footprint, camera)

  const isTouchChrome = useUiPresentationStore.getState().layout !== 'desktop'
  if (isTouchChrome) {
    view.target.y += TOUCH_DRAW_FIT_PAN_UP
    view.position.y += TOUCH_DRAW_FIT_PAN_UP + TOUCH_DRAW_FIT_EXTRA_DEPTH
  }

  applyDrawTopDownCameraView(controls, camera, view, footprint.anchorQuaternion)
  markDrawFitOrbitSyncPending()

  const fittedView = captureCameraViewFromControls(controls, camera)
  return isValidCameraView(fittedView) ? fittedView : null
}
